import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { GetCurrentUserResponseInterface } from './model';
import * as ObjectActions from './actions';
import * as UserActions from '../user/actions';
import * as _ from 'lodash';
import { MonitoringService } from '../../shared/service/error-service/monitoring.service';

@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions<ObjectActions.AppActions>,
    private http: HttpClient,
    private monitoringService: MonitoringService,
  ) {}

  private APP_URLS = {
    GET: {
      GET_CURRENT_USER: '/api/getcurrentuser',
    },
    POST: {
      // LOG_EXTERNAL_PAGE_VIEWS: '/api/log-external-page-views',
    },
  };

}
